import { Component } from "react";
import Uppy from '@uppy/core'
import { DashboardModal } from '@uppy/react'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Instagram from '@uppy/instagram';
import Url from '@uppy/url';
import Webcam from '@uppy/webcam';
import $ from 'jquery'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_BUCKET_URL, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../../../actions/constant";

const uppyKey = UPPY_KEY;
const uppyBucket =  UPPY_BUCKET;
const uppyAwsKey =  UPPY_AWS_KEY;
const uppyAwsSecret =  UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;

class Authorprofile extends Component {

    constructor(props) {
        super(props)

        this.uppyPostEdit = new Uppy({ debug: true, autoProceed: false, restrictions: { maxFileSize: 5000000, maxNumberOfFiles: 1, minNumberOfFiles: 1, allowedFileTypes: ['image/*'] } })
            .use(Transloadit, {
                target: '#a',
                params: {
                    auth: {
                        key: uppyKey
                    },
                    steps: {
                        resize: {
                            robot: '/image/resize',
                            width: 500,
                            resize_strategy: 'fit',
                            background: 'none',
                        },
                        store: {
                            robot: "/wasabi/store",
                            bucket_region: "us-west-1",
                            bucket: uppyBucket,
                            key: uppyAwsKey,
                            secret: uppyAwsSecret,
                            path: 'media/tmpimages/${file.id}.${file.ext}'
                        }
                    }
                },
                waitForEncoding: true
            })
            .use(Instagram, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(GoogleDrive, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Url, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Webcam, { target: Uppy.Dashboard, companionUrl: companionUrl })

             this.onClickToOpen = this.onClickToOpen.bind(this)
             this.onClickToClose = this.onClickToClose.bind(this)
      }
    state = {
        filename: null,
        modalOpen: false,
        updateFile : 0,
        selected: ""
    }

    componentDidMount() {  
        this.uppyPostEdit.on('transloadit:result', (stepName, result) => {
            this.setState({ selectedFile: `${result.id}.${result.ext}`, filename: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, selected: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}` }, () => {
                setTimeout(() => {
                    this.uppyPostEdit.cancelAll()
                    this.props.onImgUpload(`${result.id}.${result.ext}`)
                    this.setState({ modalOpen: false })
                }, 300)
            })

        })
    }

    onClickToOpen = () => {

        this.setState({ modalOpen: true })
        $(".uppy-Dashboard-close").click(() => {
            this.uppyPostEdit.cancelAll()
            this.setState({ modalOpen: false })
        })
    }

    
    setpostFile=(imageName)=>{ 
        this.setState({ filename: imageName,updateFile : 1 })
      }


    onClickToClose = () => {    ;
        this.uppyPostEdit.cancelAll()
        this.setState({ modalOpen: false })
    }

    componentWillUnmount() {
        this.uppyPostEdit.cancelAll()
        this.uppyPostEdit.close({ reason: 'unmount' })
        this.setState({ modalOpen: false })
    }


    render() {
    const { filename,updateFile, modalOpen } = this.state;
    const { imageName,onRemoveAuthor } = this.props

    if(imageName && updateFile==0) this.setpostFile(imageName);
    
    return (

      <>

       {filename==null ? 
         <OverlayTrigger placement="top" overlay={<Tooltip>Upload Author Image</Tooltip>}>
         <div className="symbol-label author-upload-trigger" id="authorImage" role="button" tabIndex={0} aria-label="Upload Author Image"
              onClick={() => this.onClickToOpen()}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onClickToOpen() } }}>
                    <i className="fa-regular fa-arrow-up-from-bracket"></i>
          <input type="hidden" name="data[Post][authorFile]" autoComplete="off" className="upload authorFilePic" id="authorFile" />
        </div>
         </OverlayTrigger>
        :
       <div> 
        <div onClick={() => {this.setState({filename:null});onRemoveAuthor('')}}  id="removeAuthorImage" className="border btn-circle label bg-white btn-hover-text-primary btn-shadow customtopcorner removeAuthorImage" style={{right:'-10px',position:'absolute',top:'-10px', cursor:'pointer', zIndex:'5'}}>
            <i className="fa fa-times icon-xs"> </i>
        </div>

        <div className="symbol-label" id="authorImage">
            <img   className="align-self-center uppy-btn img-fluid" id="src-block"  src={filename}></img>
                <input type="hidden" name="data[Post][authorFile]" autoComplete="off" className="upload authorFilePic" id="authorFile" />
        </div>
        </div>  
    } 
 
        {/* {modalOpen ? ( */}
          <DashboardModal
            animateOpenClose={true}
            proudlyDisplayPoweredByUppy={false}
            inline={false}
            showProgressDetails={true}
            height={750}
            browserBackButtonClose={true}
            showRemoveButtonAfterComplete={false}
            uppy={this.uppyPostEdit}
            open={modalOpen}
            onRequestCloseModal={this.onClickToClose}
            closeAfterFinish={true}
            doneButtonHandler={this.doneButtonHandler}
            plugins={["Instagram", "GoogleDrive", "Url", "Webcam"]}
          />
        {/* //) : null} */}
      </>
    );
  }
}

export default Authorprofile;
